<mobi-breadcrumb />
<mobi-ld-schema [schema]="personSchema()" />
<div class="mobi-ui-coper-header">
  @if (entity().headerImage) {
    <div
      class="hero-image-animation-wrapper lgMax:full-bleed lgMax:!rounded-none mobi-ui-margin-t-sm"
    >
      <mobi-media
        [animation]="false"
        class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
        rounded="none"
        [entity]="entity().headerImage"
        responsiveStyle="hero_single"
        [lazy]="false"
      />
    </div>
  }
</div>
<div class="page-content person-info mobi-ui-font-size-200 !mt-0">
  <mobi-content-section [content]="content">
    <ng-template #content>
      <div class="mobi-ui-grid">
        <div class="mobi-ui-col-1/3 md:mobi-ui-col-1/4 mobi-ui-margin-b-md">
          @if (entity().portrait) {
            <div
              class="person-image"
              [attr.data-delay]="100"
              [class.no-header]="!entity().headerImage"
            >
              <mobi-media [entity]="entity().portrait" responsiveStyle="person_square" />
            </div>
          }
        </div>
        <div class="mobi-ui-col-1/1 md:mobi-ui-col-3/4">
          <div class="mobi-ui-padding-y-lg">
            <h1 class="mobi-ui-font-h2">{{ entity().title }}</h1>
            @if (entity().function) {
              <mobi-text
                class="text-lead block mobi-ui-margin-b-xxl"
                [data]="entity().function"
              />
            }
            @if (entity().body) {
              <mobi-text class="text-read block" [data]="entity().body ?? ''" />
            }
          </div>
          <div class="mobi-ui-grid">
            @if (entity().year || entity().membership) {
              @if (entity().year) {
                <div class="mobi-ui-col-1/1 md:mobi-ui-col-1/2">
                  <div class="mobi-ui-card-silent mobi-ui-height-full">
                    <mobi-card
                      [cardTitle]="
                        'birth_year' | texts: { context: 'frontend', default: 'Jahrgang' }
                      "
                      [cardText]="entity().year"
                      cardStyle="info"
                      cardIcon="cake_birthday_on"
                    ></mobi-card>
                  </div>
                </div>
              }
              @if (entity().membership) {
                <div class="mobi-ui-col-1/1 md:mobi-ui-col-1/2">
                  <div class="mobi-ui-card-silent mobi-ui-height-full">
                    <mobi-card
                      cardTitle=""
                      [cardTitle]="
                        'gl_member_since'
                          | texts
                            : {
                                context: 'frontend',
                                default: 'Mitglied der Geschäftsleitung seit',
                              }
                      "
                      [cardText]="entity().membership"
                      cardStyle="info"
                      cardIcon="calendar"
                    ></mobi-card>
                  </div>
                </div>
              }
            }
            @if (entity().linkedinLink || entity().photoDownload) {
              <div class="person-socials mobi-ui-col-1/1 md:mobi-ui-col-1/2">
                <div class="mobi-ui-separator-minor mobi-ui-margin-none"></div>
                @if (entity().linkedinLink) {
                  <div>
                    <mobi-icon-link
                      [title]="
                        'linkedinLinkTitle'
                          | texts: { context: 'frontend', default: 'LinkedIn' }
                      "
                      [link]="entity().linkedinLink | extractUrl"
                      [target]="entity().linkedinLink?.options?.attributes?.target"
                      icon="linkedin"
                    />
                    <div class="mobi-ui-separator-minor !m-0"></div>
                  </div>
                }
                @if (entity().photoDownload) {
                  <div>
                    <mobi-file-download
                      type="image"
                      [file]="entity().photoDownload"
                      class="blcok"
                    />
                    <div class="mobi-ui-separator-minor !m-0"></div>
                  </div>
                }
              </div>
            }

            @if (!hideGuides()) {
              @defer (hydrate on viewport) {
                <mobi-view
                  class="w-full"
                  viewId="coper_guides"
                  display="default"
                  title="Empfohlene inhalte"
                  [argument]="{ 'views-argument': entity().id }"
                  [includes]="['field_cm_teaser_image.field_media_image']"
                  [results]="result"
                  (emptyView)="hideGuides.set($event)"
                >
                  <ng-template #result let-rows="rows">
                    @if (rows() && rows().length) {
                      <div class="mobi-ui-col-1/1 mobi-ui-margin-t-md">
                        <h5 class="mobi-ui-font-bold mobi-ui-font-realist">
                          {{
                            'coper_guides'
                              | texts: { context: 'frontend', default: 'Ratgeberartikel' }
                          }}
                        </h5>
                        <div class="mobi-ui-separator-minor mobi-ui-margin-b-none"></div>

                        @for (row of rows(); track $index) {
                          <div class="">
                            <mobi-icon-link
                              [title]="row.title"
                              [link]="row.path.alias"
                              [target]="'_self'"
                              icon="article"
                            />
                            <div class="mobi-ui-separator-minor !m-0"></div>
                          </div>
                        }
                      </div>
                    }
                  </ng-template>
                </mobi-view>
              }
            }

            @if (entity().mediaArticles?.length) {
              <div class="mobi-ui-col-1/1 mobi-ui-margin-t-md">
                <h5 class="mobi-ui-font-bold mobi-ui-font-realist">
                  {{
                    'media_articles'
                      | texts: { context: 'frontend', default: 'Medienartikel' }
                  }}
                </h5>
                <div class="mobi-ui-separator-minor mobi-ui-margin-b-none"></div>
                @for (article of entity().mediaArticles; track $index) {
                  <div class="">
                    <mobi-icon-link
                      [title]="article.title"
                      [link]="article | extractUrl"
                      [target]="article.options?.attributes?.target"
                      icon="microphone"
                    />
                    <div class="mobi-ui-separator-minor !m-0"></div>
                  </div>
                }
              </div>
            }

            @if (entity().engagements?.length) {
              <div class="mobi-ui-col-1/1 mobi-ui-margin-t-sm">
                <h5 class="mobi-ui-font-bold mobi-ui-font-realist">
                  {{
                    'engagements' | texts: { context: 'frontend', default: 'Engagements' }
                  }}
                </h5>
                <div class="mobi-ui-separator-minor mobi-ui-margin-b-none"></div>
                @for (engagement of entity().engagements; track $index) {
                  <div class="">
                    <mobi-icon-link
                      [title]="engagement.title"
                      [link]="engagement | extractUrl"
                      [target]="engagement.options?.attributes?.target"
                      icon="forest"
                    />
                    <div class="mobi-ui-separator-minor !m-0"></div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </ng-template>
  </mobi-content-section>
</div>
